import { getThemeBadgeColor } from '../../utility/badgeColors';

import type { ClipMetadata } from '../../types.ts/story';
import type { BadgeColor } from '../../utility/badgeColors';

/**
 * The tag shown at the top-left of a clip card — the prompt a clip came from,
 * or, for a reel, that it is one (PLAT-11049).
 *
 * A reel is labelled for what it is rather than for the prompt of the first
 * clip that went into it: `buildReelMetadata` copies `theme` off `clips[0]`, so
 * the card would otherwise present one contributor's prompt as the whole
 * reel's. The prompt detail stays reachable through the card's tooltip.
 *
 * Returns `null` when there is nothing to label, which the caller renders as a
 * hidden placeholder so card heights stay aligned.
 *
 * Its own module rather than an export off `VideoClipCard.tsx`: it is a pure
 * rule over clip metadata with no card in it, and the Add Clips picker now
 * labels its rows by the same rule — importing it from the card would pull that
 * whole component (and its menus, modals and stores) into the picker's module
 * graph for one function.
 */
export function clipCardTag(
  clipJson?: ClipMetadata,
): { label: string; color: BadgeColor | 'orange' } | null {
  if (!clipJson) return null;
  if (clipJson.isReel) return { label: 'Reel', color: 'purple' };
  if (clipJson.theme === 'Custom')
    return { label: 'Custom Prompt', color: 'orange' };
  if (clipJson.theme)
    return { label: clipJson.theme, color: getThemeBadgeColor(clipJson.theme) };
  return null;
}
